import { render, staticRenderFns } from "./AudioRecorderModal.vue?vue&type=template&id=3f1344f4&scoped=true&"
import script from "./AudioRecorderModal.vue?vue&type=script&lang=js&"
export * from "./AudioRecorderModal.vue?vue&type=script&lang=js&"
import style0 from "./AudioRecorderModal.vue?vue&type=style&index=0&id=3f1344f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1344f4",
  null
  
)

export default component.exports